// Small, forgiving client-side validators for the demo enquiry form.
// These intentionally accept a wide range of everyday input formats rather
// than enforcing a single strict pattern.

export function normalisePhoneDigits(value: string): string {
  return value.replace(/[^\d+]/g, '');
}

export function isValidAuPhone(value: string): boolean {
  const digits = normalisePhoneDigits(value.trim());
  if (!digits) return false;
  const localised = digits.replace(/^\+?61/, '0');
  return /^0\d{9}$/.test(localised) || /^\d{8,10}$/.test(digits.replace(/^\+/, ''));
}

export function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

export function formatAuPhoneOnBlur(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 10);
  if (digits.length <= 4) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 4)} ${digits.slice(4)}`;
  return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7, 10)}`;
}

export function isNonEmpty(value: string): boolean {
  return value.trim().length > 0;
}
